<h1 mat-dialog-title>Appointment Move Confirmation</h1>
<div mat-dialog-content>
  <p>Move Appointment to {{newDate}}?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'cancel'">Cancel</button>
  <button mat-button [mat-dialog-close]="'confirm'" cdkFocusInitial>Confirm</button>
</div>